import type { CategoryResult } from '@ab-core/graphql/dist';

const decodeName = (name?: string | null): string | undefined => {
    return name ? name.replaceAll('%2F', '/').replaceAll('%2f', '/') : undefined;
};

export const decodeCategoryNames = (category: CategoryResult): CategoryResult => ({
    ...category,
    name: decodeName(category.name),
    children: category.children?.map(decodeCategoryNames)
});
